import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/firestore'; // make sure you add this for firestore
import 'firebase/storage';
import 'firebase/performance';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGIN_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID
};

if (process.env.REACT_APP_USE_FIREBASE_EMULATORS === 'true') {
  firebase.firestore().settings({ host: 'localhost:8080', ssl: false });
  firebase.auth().useEmulator('http://localhost:9099/');
  if (firebase.functions) { firebase.functions().useFunctionsEmulator('http://localhost:5001'); }
}

firebase.initializeApp(firebaseConfig);

// Initialize other services on firebase instance
firebase.firestore();
// eslint-disable-next-line no-unused-vars
const perf = firebase.performance();
export default firebase; // <- needed if using firestore
